export class ParamEncoder {
    /**
     * Provides an standardized way to encode a string for use in a URL as a parameter. This will convert the string to lowercase
     * and replace spaces with dashes.
     */
    public static encode = (str: string) => encodeURIComponent(str.replaceAll(' ', '-').toLowerCase())
}
